<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Wuv2im/tc-custom/9781459262027.jpg?1740889331186" alt="This image is the cover for the book Getting Even, Revenge Is Sweet"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Getting Even, Revenge Is Sweet
      </h1>
      <p class="bookDescription body article font2">
        <b><i>It was time to even the score!</i></b><br/><br/>Geraint Howell-Williams was sure Lola Hennessy had used her womanly charms to make sure of her inheritancean exclusive houseby seducing another man, someone she barely knew.<br/><br/>Lola <i>was</i> beautiful, so getting close to her was no hardship, and Geraint had reasons of his own for wanting to find out more about this temptress. Seducing her would be most enjoyablea very sweet revenge.<br/><br/><b>REVENGE <i>is Sweet</i><br/>when it leads to love!</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sharon Kendrick
      </h2>
      
      <p class="authorDescription body article">Sharon Kendrick started story-telling at the age of eleven and has never stopped. She likes to write fast-paced, feel-good romances with heroes who are so sexy they&rsquo;ll make your toes curl! She&#160;lives in the beautiful city of Winchester &ndash; where she can see the cathedral from her window (when standing on tip-toe!). She has two children, Celia and Patrick and her passions include music, books, cooking and eating &ndash; and drifting into daydreams while working out new plots.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?38fdb682